/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"
import Header from "./header"

import "./bootstrap.css"
import "./blues.css"
import "./layout.css"
import "./dark.css"
import "./dus.css"
import "./aplikasikasirmini.css"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
	<div className="col-12 shadow fixed-top bg-white">
<ul className="nav justify-content-center">
  <li className="nav-item">
    <Link className="nav-link" title="aplikasi mesin kasir online" to="/">Home</Link>
  </li>
  <li className="nav-item">
    <Link className="nav-link" title="aplikasi online" to="/aplikasi">Applikasi</Link>
  </li>
  <li className="nav-item">
    <Link className="nav-link" title="mesin kasir" to="/hardware">Hardware</Link>
  </li>
  <li className="nav-item">
    <Link className="nav-link" title="hubungi mesin kasir" to="/contact">Contact</Link>
  </li>
</ul></div>
      <Header siteTitle={data.site.siteMetadata.title} />
      <div
        style={{
          margin: `0 auto`,
          maxWidth: 960,
          padding: `0 1.0875rem 1.45rem`,
        }}
      >
	  
        <main>{children}</main><hr/>
        <footer className="lead text-center"><small>
          © {new Date().getFullYear()}, <a href="/" title="mesin kasir online">mesinkasironline</a> , Built with
          {` `}
          <a href="https://www.gatsbyjs.org" target="blank">Gatsby</a> develope by  <a href="https://gatsbyart.web.app" target="blank">GatsbyArt</a></small>
        </footer>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
